export const WorkoutPlayerProgressBar = {
  bindings: {
    steps: '<',
    currentStep: '<',
    currentStepIndex: '<',
    time: '<',
  },

  template: `
    <div class="workout-player-progress-bar">
      <ul class="unstyled progress-bar-inner">
        <li class="progress-item"
          ng-repeat="step in $ctrl.steps track by $index"
          ng-style="{ width: 100 / $ctrl.steps.length + '%' }"
          ng-class="{
            'active-group': step.group.name === $ctrl.currentStep.group.name || $index <= $ctrl.currentStepIndex,
            'active-step': $index === $ctrl.currentStepIndex,
            'completed-step': $index <= $ctrl.currentStepIndex - 1,
            'final-blast': step.group.name.toLowerCase() === 'final blast',
            'first-in-group': step.firstInGroup
          }">
          <span ng-if="step.firstInGroup">{{ step.group.name }}</span>
        </li>
      </ul>
      <span class="progress-pin" ng-style="{ left: $ctrl.left + '%' }"></span>
      <span class="group-name">{{ $ctrl.currentStep.group.name }}</span>
    </div>`,

  controller() {
    'ngInject';

    return {
      $onChanges() {
        if (this.currentStep) {
          this.progressPin();
        }
      },

      progressPin() {
        const width = 100 / this.steps.length;
        const startPos = width * this.currentStepIndex;
        const endPos = width * (this.currentStepIndex + 1);

        const progress =
          (endPos - startPos) / this.currentStep.totalTimeInSeconds * this.time;

        this.left = startPos + progress;
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/WorkoutPlayer/WorkoutPlayerProgressBar.js